const LOAD_CONFIG = "LOAD_CONFIG"
const LOADED_CONFIG = "LOADED_CONFIG"

export { LOAD_CONFIG, LOADED_CONFIG }
